/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
import { AtomNumber } from './measures.js';
/**
 * Enum of element symbols
 */
export var Elements;
(function (Elements) {
    Elements["H"] = "H";
    Elements["D"] = "D";
    Elements["T"] = "T";
    Elements["HE"] = "HE";
    Elements["LI"] = "LI";
    Elements["BE"] = "BE";
    Elements["B"] = "B";
    Elements["C"] = "C";
    Elements["N"] = "N";
    Elements["O"] = "O";
    Elements["F"] = "F";
    Elements["NE"] = "NE";
    Elements["NA"] = "NA";
    Elements["MG"] = "MG";
    Elements["AL"] = "AL";
    Elements["SI"] = "SI";
    Elements["P"] = "P";
    Elements["S"] = "S";
    Elements["CL"] = "CL";
    Elements["AR"] = "AR";
    Elements["K"] = "K";
    Elements["CA"] = "CA";
    Elements["SC"] = "SC";
    Elements["TI"] = "TI";
    Elements["V"] = "V";
    Elements["CR"] = "CR";
    Elements["MN"] = "MN";
    Elements["FE"] = "FE";
    Elements["CO"] = "CO";
    Elements["NI"] = "NI";
    Elements["CU"] = "CU";
    Elements["ZN"] = "ZN";
    Elements["GA"] = "GA";
    Elements["GE"] = "GE";
    Elements["AS"] = "AS";
    Elements["SE"] = "SE";
    Elements["BR"] = "BR";
    Elements["KR"] = "KR";
    Elements["RB"] = "RB";
    Elements["SR"] = "SR";
    Elements["Y"] = "Y";
    Elements["ZR"] = "ZR";
    Elements["NB"] = "NB";
    Elements["MO"] = "MO";
    Elements["TC"] = "TC";
    Elements["RU"] = "RU";
    Elements["RH"] = "RH";
    Elements["PD"] = "PD";
    Elements["AG"] = "AG";
    Elements["CD"] = "CD";
    Elements["IN"] = "IN";
    Elements["SN"] = "SN";
    Elements["SB"] = "SB";
    Elements["TE"] = "TE";
    Elements["I"] = "I";
    Elements["XE"] = "XE";
    Elements["CS"] = "CS";
    Elements["BA"] = "BA";
    Elements["LA"] = "LA";
    Elements["CE"] = "CE";
    Elements["PR"] = "PR";
    Elements["ND"] = "ND";
    Elements["PM"] = "PM";
    Elements["SM"] = "SM";
    Elements["EU"] = "EU";
    Elements["GD"] = "GD";
    Elements["TB"] = "TB";
    Elements["DY"] = "DY";
    Elements["HO"] = "HO";
    Elements["ER"] = "ER";
    Elements["TM"] = "TM";
    Elements["YB"] = "YB";
    Elements["LU"] = "LU";
    Elements["HF"] = "HF";
    Elements["TA"] = "TA";
    Elements["W"] = "W";
    Elements["RE"] = "RE";
    Elements["OS"] = "OS";
    Elements["IR"] = "IR";
    Elements["PT"] = "PT";
    Elements["AU"] = "AU";
    Elements["HG"] = "HG";
    Elements["TL"] = "TL";
    Elements["PB"] = "PB";
    Elements["BI"] = "BI";
    Elements["PO"] = "PO";
    Elements["AT"] = "AT";
    Elements["RN"] = "RN";
    Elements["FR"] = "FR";
    Elements["RA"] = "RA";
    Elements["AC"] = "AC";
    Elements["TH"] = "TH";
    Elements["PA"] = "PA";
    Elements["U"] = "U";
    Elements["NP"] = "NP";
    Elements["PU"] = "PU";
    Elements["AM"] = "AM";
    Elements["CM"] = "CM";
    Elements["BK"] = "BK";
    Elements["CF"] = "CF";
    Elements["ES"] = "ES";
    Elements["FM"] = "FM";
    Elements["MD"] = "MD";
    Elements["NO"] = "NO";
    Elements["LR"] = "LR";
    Elements["RF"] = "RF";
    Elements["DB"] = "DB";
    Elements["SG"] = "SG";
    Elements["BH"] = "BH";
    Elements["HS"] = "HS";
    Elements["MT"] = "MT";
    Elements["DS"] = "DS";
    Elements["RG"] = "RG";
    Elements["CN"] = "CN";
    Elements["NH"] = "NH";
    Elements["FL"] = "FL";
    Elements["MC"] = "MC";
    Elements["LV"] = "LV";
    Elements["TS"] = "TS";
    Elements["OG"] = "OG";
})(Elements || (Elements = {}));
export const ElementNames = {
    H: 'Hydrogen', HE: 'Helium', LI: 'Lithium', BE: 'Beryllium', B: 'Boron', C: 'Carbon', N: 'Nitrogen', O: 'Oxygen', F: 'Fluorine', NE: 'Neon', NA: 'Sodium', MG: 'Magnesium', AL: 'Aluminum', SI: 'Silicon', P: 'Phosphorus', S: 'Sulfur', CL: 'Chlorine', AR: 'Argon', K: 'Potassium', CA: 'Calcium', SC: 'Scandium', TI: 'Titanium', V: 'Vanadium', CR: 'Chromium', MN: 'Manganese', FE: 'Iron', CO: 'Cobalt', NI: 'Nickel', CU: 'Copper', ZN: 'Zinc', GA: 'Gallium', GE: 'Germanium', AS: 'Arsenic', SE: 'Selenium', BR: 'Bromine', KR: 'Krypton', RB: 'Rubidium', SR: 'Strontium', Y: 'Yttrium', ZR: 'Zirconium', NB: 'Niobium', MO: 'Molybdenum', TC: 'Technetium', RU: 'Ruthenium', RH: 'Rhodium', PD: 'Palladium', AG: 'Silver', CD: 'Cadmium', IN: 'Indium', SN: 'Tin', SB: 'Antimony', TE: 'Tellurium', I: 'Iodine', XE: 'Xenon', CS: 'Cesium', BA: 'Barium', LA: 'Lanthanum', CE: 'Cerium', PR: 'Praseodymium', ND: 'Neodymium', PM: 'Promethium', SM: 'Samarium', EU: 'Europium', GD: 'Gadolinium', TB: 'Terbium', DY: 'Dysprosium', HO: 'Holmium', ER: 'Erbium', TM: 'Thulium', YB: 'Ytterbium', LU: 'Lutetium', HF: 'Hafnium', TA: 'Tantalum', W: 'Wolfram', RE: 'Rhenium', OS: 'Osmium', IR: 'Iridium', PT: 'Platinum', AU: 'Gold', HG: 'Mercury', TL: 'Thallium', PB: 'Lead', BI: 'Bismuth', PO: 'Polonium', AT: 'Astatine', RN: 'Radon', FR: 'Francium', RA: 'Radium', AC: 'Actinium', TH: 'Thorium', PA: 'Protactinium', U: 'Uranium', NP: 'Neptunium', PU: 'Plutonium', AM: 'Americium', CM: 'Curium', BK: 'Berkelium', CF: 'Californium', ES: 'Einsteinium', FM: 'Fermium', MD: 'Mendelevium', NO: 'Nobelium', LR: 'Lawrencium', RF: 'Rutherfordium', DB: 'Dubnium', SG: 'Seaborgium', BH: 'Bohrium', HS: 'Hassium', MT: 'Meitnerium', DS: 'Darmstadtium', RG: 'Roentgenium', CN: 'Copernicium', NH: 'Nihonium', FL: 'Flerovium', MC: 'Moscovium', LV: 'Livermorium', TS: 'Tennessine', OG: 'Oganesson'
};
export const AlkaliMetals = new Set(['LI', 'NA', 'K', 'RB', 'CS', 'FR']);
export function isAlkaliMetal(element) { return AlkaliMetals.has(element); }
export const AlkalineEarthMetals = new Set(['BE', 'MG', 'CA', 'SR', 'BA', 'RA']);
export function isAlkalineEarthMetal(element) { return AlkalineEarthMetals.has(element); }
export const PolyatomicNonmetals = new Set(['C', 'P', 'S', 'SE']);
export function isPolyatomicNonmetal(element) { return PolyatomicNonmetals.has(element); }
export const DiatomicNonmetals = new Set(['H', 'N', 'O', 'F', 'CL', 'BR', 'I']);
export function isDiatomicNonmetal(element) { return DiatomicNonmetals.has(element); }
export const NobleGases = new Set(['HE', 'NE', 'AR', 'KR', 'XE', 'RN']);
export function isNobleGas(element) { return NobleGases.has(element); }
export const PostTransitionMetals = new Set(['ZN', 'GA', 'CD', 'IN', 'SN', 'HG', 'TI', 'PB', 'BI', 'PO', 'CN']);
export function isPostTransitionMetal(element) { return PostTransitionMetals.has(element); }
export const Metalloids = new Set(['B', 'SI', 'GE', 'AS', 'SB', 'TE', 'AT']);
export function isMetalloid(element) { return Metalloids.has(element); }
export const Halogens = new Set(['F', 'CL', 'BR', 'I', 'AT']);
export function isHalogen(element) { return Halogens.has(element); }
export function isTransitionMetal(element) {
    const no = AtomNumber(element);
    return ((no >= 21 && no <= 29) ||
        (no >= 39 && no <= 47) ||
        (no >= 72 && no <= 79) ||
        (no >= 104 && no <= 108));
}
export function isLanthanide(element) {
    const no = AtomNumber(element);
    return no >= 57 && no <= 71;
}
export function isActinide(element) {
    const no = AtomNumber(element);
    return no >= 89 && no <= 103;
}
export function isMetal(element) {
    return (isAlkaliMetal(element) ||
        isAlkalineEarthMetal(element) ||
        isLanthanide(element) ||
        isActinide(element) ||
        isTransitionMetal(element) ||
        isPostTransitionMetal(element));
}
export function isNonmetal(element) {
    return (isDiatomicNonmetal(element) ||
        isPolyatomicNonmetal(element) ||
        isNobleGas(element));
}
